import { render, staticRenderFns } from "./WebGLViewer.vue?vue&type=template&id=3602fb4a&scoped=true&"
import script from "./WebGLViewer.vue?vue&type=script&lang=js&"
export * from "./WebGLViewer.vue?vue&type=script&lang=js&"
import style0 from "./WebGLViewer.vue?vue&type=style&index=0&id=3602fb4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3602fb4a",
  null
  
)

export default component.exports